"use strict";

const expandedFacetLists = new Set();

const funnelbackCollection = window.location.hostname === 'portfolio.arts.ac.uk' ? "ual~sp-portfolio" : "ual~sp-portfolio-dev";

let searchConfig = {
  url: "https://ual-search.arts.ac.uk/s/search.json",
  collections: [funnelbackCollection],
  additionalFBparams: {
    profile: '_defaults',
  },
  results: {
    numRanks: 12,
  },
  search: {
    target: '.form',
    inputId: 'keyword-search',
    resetFacets: false,
  },
  scroll: {
    enable: true,
  },
  information: {
    target: '.information-container'
  },
  pagination: {
    target: '.pagination',
    dots: true,
    arrows: true,
    pages: 3,
  },
  noResults: {
    target: '.no-results',
  },
  onFiltersUpdate: function onFiltersUpdate() {
    collapseCourseList();
  },
  facets: {
    items: [
      {
        name: "Sensitive Content",
        type: "checkbox",
        options: {
          singleChoice: true,
          facetsRestricted: true,
          template: ({ name, allValues, singleChoice }, activeFacets, h) => {
          let list = '';
            allValues.forEach((item) => {
              if (item.data === "1" && (item.count > 0 || item.selected )) {
                list += `
                  <li class="form-check">
                    <label for="${name}" class="form-check-label">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value="${name}"
                        name="sensitive"
                        id="${name}"
                        data-fparam="${item.toggleUrl}"
                        data-singlechoice="${singleChoice}"
                        ${item.selected ? 'checked' : ''} />
                      <span class="check-indicator"></span>
                      Include sensitive material
                    </label>
                  </li>`;
              }
            });  
            if (!list) return '';
            return `
              <div class="form-group">
                <fieldset class="checkbox-facet">
                  <ul class="facet-list">
                    ${list}
                  </ul>
                </fieldset>
              </div>`;
          }
        },
      },        
      {
        name: "Colleges",
        type: "checkbox",
        options: {
          singleChoice: true,
          facetsRestricted: true,
        },
      },
      {
        name: "Courses",
        type: "checkbox",
        options: {
          singleChoice: true,
          facetsRestricted: true,
        },
      },
      {
        name: "Final Year",
        type: "checkbox",
        options: {
          singleChoice: true,
          facetsRestricted: true,
          template: ({ name, allValues, singleChoice, label }, activeFacets, h) => {
            let list = '';
            allValues.forEach((item) => {
              if (item.data === "1" && (item.count > 0 || item.selected )) {
                list += `
                  <li class="form-check">
                    <label for="${name}" class="form-check-label">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value="${name}"
                        name="finalyear"
                        id="${name}"
                        data-fparam="${item.toggleUrl}"
                        data-singlechoice="${singleChoice}"
                        ${item.selected ? 'checked' : ''} />
                      <span class="check-indicator"></span>
                      Final year projects
                    </label>
                  </li>`;
              }
            });
            if (!list) return '';
            return `
              <div class="form-group">
                <fieldset class="checkbox-facet">
                  <legend>Year added</legend>
                  <ul class="facet-list">
                    ${list}
                  </ul>
                </fieldset>
              </div>`;
          }
        },
      },
    ],
  },
  templates: {
    formTemplate: (search, query, inputId) => {
      return `
       <form id="main-search" action="#results">
          <div class="filter-keyword">
          <label for="${inputId}" class="hidden">Keyword search</label>
            <div class="form-inline">
              <input
                required
                aria-label="Search field"
                id="${inputId}"
                type="search"
                value="${query !== "!nullquery" ? query : ''}"
                name="searchquery"
                placeholder="Search Portfolio"
                class="form-control"
                autocomplete="off"
              />
              <input title="Browse" class="btn search-submit btn-primary" type="submit" value="Search">
              <ul class="terms-list">
              <li class="template hidden" aria-hidden="true">
                <a href="#" aria-hidden="true">
                Search keywords...</a>
              </li>
              </ul>
            </div>
          </div>
        </form>
      `;
    },
    informationTemplate: function informationTemplate(fields, resultsSummary, h) {
      const q = fields.question.query;
      if (q === "finalyear" || q === "!nullsearch" ){
        return "";
      }
      const displayQuery = decodeURIComponent(q).replace(/\+/g, " ");
      return `
              <span class='information-text'>
                <strong>${resultsSummary.totalMatching} results</strong>
                searching for <strong>"${displayQuery}"</strong>
              </span>
            `;
    },
    articleTemplate: function articleTemplate(fields, fieldsHighlighted) {
      const isFlashing = fields.listMetadata.flashingImages && fields.listMetadata.flashingImages[0] === '1';
      const isSensitive = fields.listMetadata.sensitiveContent && fields.listMetadata.sensitiveContent[0] === '1';

      const tags = (fields.listMetadata.tags || []);
      const reorderedTags = [
        ...tags.filter(tag => tag.toLowerCase() === 'finalyear'),
        ...tags.filter(tag => tag.toLowerCase() !== 'finalyear'),
      ];

      const formattedTags = reorderedTags.map(tag => {
        if (tag.toLowerCase() === 'finalyear') {
          return `<a class="tag" href="/search?&profile=_defaults&f.Final+Year%7CfinalYear=1">#${tag}</a>`;
        }
        return `<a class="tag" href="/search?&profile=_defaults&query=${tag}">#${tag}</a>`;
      })
        .join(' ');

      return `
        <div class="result-item">
        <div class="result-item-inner">
        <div class="result-img-container">
        <img src="${window.location.hostname === 'portfolio.arts.ac.uk' ? fields.listMetadata.image : fields.listMetadata.image[0].replace(/^https:\/\/ual-media-res\.cloudinary\.com\/image\/fetch\/c_crop,h_500,w_500\//, '')}" alt="${fields.title}"  class="result-img ${isSensitive ? 'sensitive' : ''}" />
        ${isSensitive ? `<div class="sensitive-content"><span></span></div>` : ''}
        </div>
        <div class="result-content" data-mh="result-match">
    
          <h3>
            <a href="${fields.liveUrl}">
              ${fields.title}
            </a>
          </h3>
      <span class="small-text"> 
      By
      <a href="${fields.listMetadata.profileUrl}">
        ${fields.listMetadata.studentName}
            </a>
              ${fields.listMetadata.createdDate}
            </span>
            ${formattedTags ? `<span class="tags">${formattedTags}</span>` : ''}
            ${isFlashing ? `<div class="warning__flashing-images result-card">
              <svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 19L11 0L22 19H0ZM3.45 17H18.55L11 4L3.45 17ZM11 16C11.2833 16 11.521 15.904 11.713 15.712C11.9043 15.5207 12 15.2833 12 15C12 14.7167 11.9043 14.4793 11.713 14.288C11.521 14.096 11.2833 14 11 14C10.7167 14 10.4793 14.096 10.288 14.288C10.096 14.4793 10 14.7167 10 15C10 15.2833 10.096 15.5207 10.288 15.712C10.4793 15.904 10.7167 16 11 16ZM10 13H12V8H10V13Z" fill="black"></path>
              </svg>
              <p>Warning: flashing images</p>
            </div>` : ''}
        </div>
      </div>
      `;
    },
    paginationNumberTemplate: function paginationNumberTemplate(number, startrank) {
      return (
        '<li><button data-startrank="' + startrank + '">' +
        number +
        '</button></li>'
      );
    },
    activePaginationNumberTemplate: function activePaginationNumberTemplate(number) {
      return (
        '<li class="current"><button>' +
        number +
        "</button></li>"
      );
    },
    arrowNextTemplate: function arrowNextTemplate(startrank) {
      return (
        '<li class="next-arrow">' +
        '<button aria-label="Next page" data-startrank="' + startrank + '">' +
        'Next <span class="show-for-sr">page</span>' +
        '</button>' +
        '</li>'
      );
    },
    arrowPrevTemplate: function arrowPrevTemplate(startrank) {
      return (
        '<li class="prev-arrow">' +
        '<button aria-label="Previous page" data-startrank="' + startrank + '">' +
        'Previous <span class="show-for-sr">page</span>' +
        '</button>' +
        '</li>'
      );
    },
    paginationTemplate: function paginationTemplate(pages) {
      return (
        '<ul class="pagination-list">' +
        pages +
        "</ul>"
      );
    },
    dotsPaginationTemplate: () => {
      return '<li class="dots-page">...</li>';
    },
    noResults: (query, spell) => {
      return `
        <h2>No results for your search</h2>
        <p>Please try again.</p>`
    },
    facetCheckbox: ({ name, allValues, singleChoice, label }, activeFacets, h) => {
      const uniqueFacet = new Set();
      const selected = name  && allValues.some(item => item.selected);
      let listHtml = '';

      allValues.forEach(item => {
        if (uniqueFacet.has(item.data)) return;
        uniqueFacet.add(item.data);
        
        if (name === 'Courses' && selected && !item.selected) {
          return; 
        }

          listHtml += `
            <li class="form-check">
              <label for="${item.data}" class="form-check-label">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="${item.data}"
                  name="${item.data}"
                  value="${item.data}"
                  data-fparam="${item.toggleUrl}"
                  data-singlechoice="${singleChoice}"
                  ${item.selected ? 'checked' : ''} 
                />
                ${item.data} 
                <span class="check-indicator"></span>
              </label>
            </li>`;
      });
      let toggleBar = '';
      if (name === 'Courses' && uniqueFacet.size > 2 && !selected) {
        toggleBar = `
          <span class="show-more" tabindex="0">
            <span class="more">Expand</span>
            <span class="less">Collapse</span>
          </span>`;
      }
      if (!listHtml) return '';
      return `
        <div class="form-group">
          <div class="col-md-12">
            <fieldset class="checkbox-facet">
              <legend>${name}</legend>
              <ul class="facet-list filter-${name} ${name === 'Courses' && uniqueFacet.size > 2 && !selected ? 'collapsed-course-list' : ''}" data-facet-id="${name}">
                ${listHtml}
              </ul>
              ${toggleBar}
            </fieldset>
          </div>
        </div>`;
    }
  },
};

function setFacetListState(list, expand) {
  const items = list.querySelectorAll('li');
  const showMore = list.nextElementSibling;
  const facetId = list.dataset.facetId;

  list.classList.toggle('collapsed-course-list', !expand);
  showMore?.classList.toggle('open', expand);

  items.forEach((item, index) => {
    item.style.display = expand || index < 2 ? 'list-item' : 'none';
  });

  if (facetId) {
    if (expand) {
      expandedFacetLists.add(facetId);
    } else {
      expandedFacetLists.delete(facetId);
    }
  }
}

function collapseCourseList() {
  const facetLists = document.querySelectorAll('.facet-list');
  facetLists.forEach(list => {
    const items = list.querySelectorAll('li');
    if (items.length <= 2) return;
    const facetId = list.dataset.facetId;
    const isExpanded = facetId && expandedFacetLists.has(facetId);
    setFacetListState(list, !!isExpanded);
  });
}

function showMore() {
  document.addEventListener('click', handleShowMoreToggle);
  document.addEventListener('keydown', function (e) {
    if ( e.key === " " || e.key === "Enter") {
      handleShowMoreToggle(e);
    }
  });
}
function handleShowMoreToggle(e) {
  const showMore = e.target.closest('.show-more');
  if (!showMore) return;
  const list = showMore.previousElementSibling;
  if (!list) return;

  const isCollapsed = list.classList.contains('collapsed-course-list');
  setFacetListState(list, isCollapsed);
}

let mySearch = new Search.default(searchConfig);
mySearch.init();
showMore();
collapseCourseList()




